// extracted by mini-css-extract-plugin
export var danger = "_13-6";
export var lightPink = "_13-a";
export var medium = "_13-j";
export var nearSquare = "_13-m";
export var neutralBlue = "_13-8";
export var neutralYellow = "_13-7";
export var noCapitalize = "_13-1";
export var normal = "_13-2";
export var pill = "_13-0";
export var primary = "_13-3";
export var primaryLight = "_13-4";
export var shadow = "_13-n";
export var small = "_13-k";
export var solidBlack = "_13-i";
export var solidGreen = "_13-d";
export var solidLightBlue = "_13-f";
export var solidNavy = "_13-e";
export var solidOrange = "_13-h";
export var solidPink = "_13-g";
export var solidRed = "_13-b";
export var solidWhite = "_13-9";
export var solidYellow = "_13-c";
export var success = "_13-5";
export var xsmall = "_13-l";